import React from 'react'
import { Grid } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import CopilotCategoryTitle from '../CopilotCategoryTitle'
import CopilotSettingsEmptyState from './CopilotSettingsEmptyState'
import CopilotSettingsList from './CopilotSettingsList'
import CopilotSettingsSkeleton from './CopilotSettingsSkeleton'
import usePatientCopilotSettings from './usePatientCopilotSettings'

const CopilotSettings = ({ analyticsPayload }) => {
  const { t } = useTranslation()

  const { categories, hasPatientBrief, isLoading, openPatientBriefModal } = usePatientCopilotSettings()

  return (
    <Grid container direction="column" spacing={1}>
      <Grid item>
        <CopilotCategoryTitle>
          {t('pages.patients.patientSidebar.items.copilot.copilotSettings.title')}
        </CopilotCategoryTitle>
      </Grid>
      {!hasPatientBrief ? (
        <CopilotSettingsEmptyState />
      ) : isLoading ? (
        <Grid item>
          <CopilotSettingsSkeleton />
        </Grid>
      ) : (
        <Grid item>
          <CopilotSettingsList
            categories={categories}
            onOpenPatientBriefEditorClicked={openPatientBriefModal}
            analyticsPayload={analyticsPayload}
          />
        </Grid>
      )}
    </Grid>
  )
}

export default CopilotSettings
